import { render, staticRenderFns } from "./distributor_center.vue?vue&type=template&id=0eda4abd&scoped=true&"
import script from "./distributor_center.vue?vue&type=script&lang=js&"
export * from "./distributor_center.vue?vue&type=script&lang=js&"
import style0 from "./distributor_center.vue?vue&type=style&index=0&id=0eda4abd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eda4abd",
  null
  
)

export default component.exports